import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css"; // Ensure you have a footer CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="copyright">© 2025 Next Remedy. All rights reserved.</div>
      <nav>
        <Link to="/">Home</Link> | 
        <Link to="/privacy-policy"> Privacy Policy</Link> | 
        <Link to="/terms-of-service"> Terms of Service</Link>
      </nav>
    </footer>
  );
};

export default Footer;